import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PlatformProviders } from '@/app/shared/PlatformProviders';
import { UserProvider } from '@/contexts/UserContext';
import GlobalAlertHandler from '@/shared/components/GlobalAlertHandler';
import { ErrorBoundaryWithRecovery } from '@/shared/components/ErrorBoundary';
import { AppShellGate } from '@/app/shared/AppShellGate';
import { startAppVersionWatcher } from '@/app/shared/checkAppVersion';

/**
 * Root app: shared providers + role-based shell (platform vs tenant routes).
 */
export default function App() {
  useEffect(() => startAppVersionWatcher(), []);

  return (
    <PlatformProviders>
      <BrowserRouter>
        <GlobalAlertHandler />
        <UserProvider>
          <ErrorBoundaryWithRecovery>
            <AppShellGate />
          </ErrorBoundaryWithRecovery>
        </UserProvider>
      </BrowserRouter>
    </PlatformProviders>
  );
}
